import { pgTable, text, boolean, timestamp, integer, index, foreignKey, numeric, uniqueIndex, jsonb } from 'drizzle-orm/pg-core';
import { sql } from 'drizzle-orm';
import { promoDiscountType, promoTargetType } from './enums';
import { user } from './user';
import { order } from './commerce';

export const promoCode = pgTable('PromoCode', {
  id: integer().primaryKey().generatedAlwaysAsIdentity(),
  code: text().notNull(),
  discountType: promoDiscountType().notNull(),
  value: numeric({ precision: 12, scale: 2 }),
  targetType: promoTargetType().notNull().default('ALL'),
  targetIds: integer().array(),
  maxActivations: integer(),
  activationsCount: integer().notNull().default(0),
  maxActivationsPerUser: integer(),
  minOrderAmount: numeric({ precision: 12, scale: 2 }),
  startsAt: timestamp({ precision: 3, mode: 'date' }),
  endsAt: timestamp({ precision: 3, mode: 'date' }),
  /** SegmentDefinition (jsonb). NULL = доступен всем, без ограничения аудитории. */
  audienceSegment: jsonb(),
  /** TRUE = автоскидка (применяется без кода, виден в разделе «Скидки»). FALSE = классический промокод. */
  autoApply: boolean().notNull().default(false),
  isActive: boolean().notNull().default(true),
  createdAt: timestamp({ precision: 3, mode: 'date' }).default(sql`CURRENT_TIMESTAMP`).notNull(),
  updatedAt: timestamp({ precision: 3, mode: 'date' }).notNull(),
}, (table) => [
  uniqueIndex('PromoCode_code_key').on(table.code),
  index('PromoCode_isActive_idx').using('btree', table.isActive.asc().nullsLast()),
  index('PromoCode_endsAt_idx').using('btree', table.endsAt.asc().nullsLast()),
]);

export const promoCodeUsage = pgTable('PromoCodeUsage', {
  id: integer().primaryKey().generatedAlwaysAsIdentity(),
  promoCodeId: integer().notNull(),
  userId: integer().notNull(),
  orderId: integer().notNull(),
  discountAmount: numeric({ precision: 12, scale: 2 }).notNull(),
  appliedAt: timestamp({ precision: 3, mode: 'date' }).default(sql`CURRENT_TIMESTAMP`).notNull(),
}, (table) => [
  index('PromoCodeUsage_promoCodeId_idx').using('btree', table.promoCodeId.asc().nullsLast()),
  index('PromoCodeUsage_userId_idx').using('btree', table.userId.asc().nullsLast()),
  index('PromoCodeUsage_orderId_idx').using('btree', table.orderId.asc().nullsLast()),
  index('PromoCodeUsage_promoCodeId_userId_idx').using('btree', table.promoCodeId.asc().nullsLast(), table.userId.asc().nullsLast()),
  foreignKey({
    columns: [table.promoCodeId],
    foreignColumns: [promoCode.id],
    name: 'PromoCodeUsage_promoCodeId_fkey',
  }).onUpdate('cascade').onDelete('cascade'),
  foreignKey({
    columns: [table.userId],
    foreignColumns: [user.id],
    name: 'PromoCodeUsage_userId_fkey',
  }).onUpdate('cascade').onDelete('cascade'),
  foreignKey({
    columns: [table.orderId],
    foreignColumns: [order.id],
    name: 'PromoCodeUsage_orderId_fkey',
  }).onUpdate('cascade').onDelete('cascade'),
]);
